import icon from './icon.png';

export const AwsIcon = () => (<img style={{ width: '20px', height: '20px' }} alt="aws" src={icon} />);